import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import type { TPatchContractorPaymentDeductionRequest } from "./patchContractorPaymentDeduction.schema";

export const patchContractorPaymentDeduction = (axios: IAxiosInstance) => {
  return async (
    body: TPatchContractorPaymentDeductionRequest
  ): Promise<void> => {
    const response = await axios.noRetry.patch<IApiResponse<unknown>>(
      "/api/contractor-payments/deductions",
      body
    );
    const data = response.data;

    if (data.success) {
      return;
    }

    throw new Error("Failed to update deduction on contractor payment");
  };
};
